"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const ontario_design_system_component_library_react_1 = require("@ongov/ontario-design-system-component-library-react");
const utils_1 = require("../../utils/utils");
const google_maps_context_provider_1 = require("../google-maps-context-provider");
const location_auto_complete_1 = __importDefault(require("../location-auto-complete"));
const location_error_summary_1 = __importDefault(require("../location-error-summary"));
const location_inline_error_1 = __importDefault(require("../location-inline-error"));
const not_found_view_1 = __importDefault(require("./not-found-view"));
const location_search_current_location_1 = __importDefault(require("../location-search-current-location"));
require("./styles.scss");
const LocationSearchBox = ({ headingTransKey, customLocations, customLocationIcon, searchParams, hideMapImg, hideButton, hideErrorBanner, errorBannerRef, updateErrors, removeError, childError, serviceError = false, setServiceError }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isLoaded } = (0, react_1.useContext)(google_maps_context_provider_1.GoogleMapsContext);
    const [location, setLocation] = (0, react_1.useState)();
    const [locating, setLocating] = (0, react_1.useState)(false);
    const [showError, setShowError] = (0, react_1.useState)(false);
    const [showLocationError, setShowLocationError] = (0, react_1.useState)(false);
    const [locationNotFound, setLocationNotFound] = (0, react_1.useState)(false);
    const [submitError, setSubmitError] = (0, react_1.useState)(false);
    const geocoder = (0, react_1.useRef)(null);
    const validateFuncRef = (0, react_1.useRef)();
    const defaultErrorSummaryRef = (0, react_1.useRef)(null);
    const errorSummaryRef = errorBannerRef !== null && errorBannerRef !== void 0 ? errorBannerRef : defaultErrorSummaryRef;
    if (isLoaded && geocoder.current === null) {
        geocoder.current = new google.maps.Geocoder();
    }
    const onSubmit = async (e) => {
        e.preventDefault();
        // check for service error
        await onSearch();
    };
    const errObj = (0, react_1.useMemo)(() => {
        return { id: `location-input-error-1`,
            errorMessage: ((0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { i18nKey: "searchBox.errors.locationRequiredSummary" })),
            inputId: `location-search-autocomplete-input` };
    }, []);
    (0, react_1.useEffect)(() => {
        if (updateErrors && removeError) {
            if (showLocationError) {
                updateErrors(errObj);
            }
            else {
                removeError(errObj.id);
            }
        }
    }, [showLocationError]);
    const hasServiceError = () => {
        if (childError) {
            setServiceError && setServiceError(true);
            return true;
        }
        return false;
    };
    const onSearch = async () => {
        if (validateFuncRef.current === undefined) {
            setShowLocationError(true);
            hasServiceError();
            return;
        }
        const result = validateFuncRef.current();
        if (result.valid) {
            setShowLocationError(false);
            if (!hasServiceError()) {
                (0, utils_1.doSearchBox)(location, t, searchParams);
            }
            return;
        }
        if (result.error === "ENTER_LOCATION_TO_CONTINUE") {
            setLocation({ name: "", lat: NaN, lng: NaN });
            setShowLocationError(true);
            hasServiceError();
            setSubmitError(true);
            return;
        }
        if (result.error === "GEOCODE_REQUIRED") {
            try {
                if (geocoder.current) {
                    const response = await geocoder.current.geocode({
                        address: result.input,
                    });
                    if (response.results.length > 0) {
                        const foundLocation = {
                            name: response.results[0].formatted_address,
                            lat: response.results[0].geometry.location.lat(),
                            lng: response.results[0].geometry.location.lng(),
                        };
                        setShowLocationError(false);
                        setLocation(foundLocation);
                        if (!hasServiceError()) {
                            (0, utils_1.doSearchBox)(foundLocation, t, searchParams);
                        }
                        return;
                    }
                }
            }
            catch (e) {
                // do nothing, handle it the same way you would below...
            }
            setShowLocationError(true);
            hasServiceError();
            setSubmitError(true);
            setLocation({ name: result === null || result === void 0 ? void 0 : result.input, lat: NaN, lng: NaN });
            return;
        }
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (submitError) {
            (_a = errorSummaryRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        setSubmitError(false);
    }, [submitError]);
    (0, react_1.useEffect)(() => {
        if (location && location.name.length > 0) {
            setShowLocationError(false);
            setLocationNotFound(false);
        }
    }, [location]);
    (0, react_1.useEffect)(() => {
        setShowError(showLocationError || serviceError);
    }, [showLocationError, serviceError]);
    const errorSummaryComponent = (0, react_1.useMemo)(() => {
        return ((0, jsx_runtime_1.jsx)(location_error_summary_1.default, { errorSummaryRef: errorSummaryRef, customErrors: [errObj] }));
    }, [showError]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!hideErrorBanner && showLocationError && errorSummaryComponent, (0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "location-search-box", className: "ontario-columns" }, { children: [(0, jsx_runtime_1.jsx)("form", Object.assign({ noValidate: true, onSubmit: onSubmit, id: "location-search-box-form" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "SearchBox" }, { children: [(0, jsx_runtime_1.jsx)("h3", Object.assign({ id: `search-box-title-${headingTransKey}`, className: "ontario-h5" }, { children: (0, jsx_runtime_1.jsxs)("label", Object.assign({ id: "location-search-autocomplete", htmlFor: "location-search-autocomplete-input" }, { children: [headingTransKey
                                                ? t(`searchBox.customHeading.${headingTransKey}`)
                                                : t("searchBox.heading"), " ", (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "ontario-label__flag" }, { children: t("searchBox.required") }))] })) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "small-12 columns" }, { children: [(0, jsx_runtime_1.jsx)("p", Object.assign({ className: "ontario-hint", id: "location-search-autocomplete-hint-text" }, { children: t("searchBox.label") })), showLocationError && ((0, jsx_runtime_1.jsx)(location_inline_error_1.default, { location: location, errorId: `location-input-error-1` })), (0, jsx_runtime_1.jsx)(location_auto_complete_1.default, { customLocations: customLocations, customLocationIcon: customLocationIcon, htmlId: "location-search-autocomplete", location: location, setLocation: setLocation, locating: locating, error: showLocationError, ariaInvalid: showLocationError, validateFuncRef: validateFuncRef, onFocus: () => { } }), locationNotFound && (0, jsx_runtime_1.jsx)(not_found_view_1.default, {})] })) })), (0, jsx_runtime_1.jsx)(location_search_current_location_1.default, { setLocating: setLocating, setShowError: setShowLocationError, setLocationNotFound: setLocationNotFound, setLocation: setLocation }), !hideButton && ((0, jsx_runtime_1.jsx)(ontario_design_system_component_library_react_1.OntarioButton, Object.assign({ nonce: undefined, onResize: undefined, onResizeCapture: undefined, placeholder: undefined, onPointerEnterCapture: undefined, onPointerLeaveCapture: undefined, type: "primary", onClick: onSearch }, { children: t("searchBox.button") })))] })) })), !hideMapImg && (0, jsx_runtime_1.jsx)("div", { className: "MapImage" })] }))] }));
};
exports.default = LocationSearchBox;
